import { FC } from 'react';

// https://dev.to/
const Location: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    role="img"
    aria-labelledby="aqae6v5n406n5wiwvtses5qz2mep5lpf"
  >
    <title id="aqae6v5n406n5wiwvtses5qz2mep5lpf">Location</title>
    <path d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1112.728 0zM12 13a2 2 0 100-4 2 2 0 000 4z"></path>
  </svg>
);

export default Location;
